<template>
  <div>
    <div class="login">
      <!-- 标题 -->
      <div class="top-head-left">
        <img :src="protectEasyLogo" style="width: 115px;" />
      </div>
      <!-- 使用手册 -->
      <div class="top-head-right-float">
        <div class="top-head-right-prev">
          <Select
            v-model="product"
            :placeholder="
              $t('permission_configuration_management.smsLogin.product')
            "
            style="color: #fff;"
            :transfer="true"
            @on-change="handleChangeProduct"
          >
            <Option :value="p.value" :key="p.value" v-for="p in productList">{{
              p.label
            }}</Option>
          </Select>
        </div>
        <!-- 右侧 -->
        <div class="top-head-right">
          <Select
            v-model="language"
            style="color: #fff;"
            :transfer="true"
            @on-change="changeLanguage(language)"
          >
            <Option
              v-for="(item, index) in languageList"
              :value="item.value"
              :key="index"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
      </div>
      <!--用户登录  -->
      <div class="login-content" v-if="showLogin == false">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <h3 class="login-title">
            ETOOLINING<span style="margin-left:10px;font-size:13px;"
              >v{{ version }}</span
            >
          </h3>
          <!-- 用户名 -->
          <FormItem prop="name" class="login-user">
            <Icon type="md-person" class="login-icon" />
            <input
              v-model="formValidate.name"
              :placeholder="$t('common.userName')"
              autocomplete="off"
            />
          </FormItem>
          <!-- 密码 -->
          <FormItem class="login-user" prop="password">
            <Icon type="md-lock" class="login-icon" />
            <input
              v-model="formValidate.password"
              :placeholder="$t('common.password')"
              type="password"
              autocomplete="new-password"
            />
          </FormItem>
          <Button type="primary" @click="login('formValidate')">{{
            $t("common.login")
          }}</Button>
          <div>
            <!-- <div class="register" @click="register">
              {{ $t("common.register") }}
            </div> -->
            <div class="forget-password" @click="forgetPassword">
              {{ $t("common.forgetPassword") }}
            </div>
          </div>
        </Form>
      </div>
      <div v-else>
        <div class="login-content">
          <Form ref="SMSFormValidate" :model="SMSFormData" :rules="SMSRule">
            <h3 class="login-title">
              {{
                $t(
                  "permission_configuration_management.smsLogin.SMSAuthenticationLogin"
                )
              }}
            </h3>
            <FormItem prop="name" class="login-user">
              <div class="tel-container">
                <input
                  v-model="showPhone"
                  :placeholder="
                    $t(
                      'permission_configuration_management.smsLogin.plaTelPhone'
                    )
                  "
                  disabled
                  autocomplete="off"
                />
              </div>
            </FormItem>
            <FormItem class="login-user tel-login-user">
              <Icon type="md-lock" class="login-icon" />
              <input
                v-model="SMSFormData.code"
                type="number"
                :placeholder="
                  $t(
                    'permission_configuration_management.smsLogin.plaVerificationCode'
                  )
                "
                :style="$i18n.locale == 'zh' ? 'width:310px' : 'width:250px'"
              />
              <Button
                type="text"
                :disabled="disabled"
                @click="sendCode"
                class="btn-text"
              >
                {{ text }}
              </Button>
            </FormItem>

            <Button type="primary" @click="loginSMS('SMSFormValidate')">{{
              $t("common.login")
            }}</Button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  setCookie,
  getCookie,
  delCookie
} from "../../../../utils/cookieUtil.js";
import topHead from "../../../TopHead";
export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      protectEasyLogo: require("../../../../../static/images/silverlining-logo.png"),
      getRouter: [],
      menuList: [],
      version: "",
      companyIdList: [],
      departmentList: [],
      languageList: [
        {
          value: "zh",
          label: "中文"
        },
        {
          value: "en",
          label: "English"
        }
      ],
      language: "zh",
      formValidate: {
        name: "",
        password: ""
      },
      SMSFormData: {
        phone: "",
        code: ""
      },
      ruleValidate: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      SMSRule: {},
      showLogin: false,
      disabled: false,
      text: "",
      getStatus: 0,
      getUserId: 0,
      getSMSData: {},
      showPhone: 0,
      run: null,
      product: "",
      productList: []
    };
  },
  mounted: function() {
    this.getVersion();
    var isCookie = document.cookie.indexOf(global.cookieName);
    // 初始化为中文
    localStorage.setItem("locale", this.language);
    this.$i18n.locale = localStorage.getItem("locale");
    this.text = this.$t(
      "permission_configuration_management.smsLogin.getVerificationCode"
    );
    // 监听浏览器返回按钮
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.back);
    }
    this.productList = [
      {
        value: 1,
        label: this.$t("permission_configuration_management.smsLogin.subscribe")
      },
      {
        value: 2,
        label: this.$t("permission_configuration_management.smsLogin.doc")
      }
    ];
  },
  destroyed() {
    window.removeEventListener("popstate", this.back);
  },
  watch: {
    text: {
      handler(newVal, oldVal) {
        oldVal = this.$t(
          "permission_configuration_management.smsLogin.getVerificationCode"
        );
        if (!!newVal) {
          this.text = newVal;
        } else {
          this.text = oldVal;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    back() {
      this.$router.push({ path: "/login" });
      this.showLogin = false;
    },
    sendCode() {
      if (!this.SMSFormData.phone) {
        this.$Message.error(
          this.$t("permission_configuration_management.smsLogin.plaTelPhone")
        );
        return;
      }
      this.$api.user
        .sendSmsCode({ id: this.getUserId, phone: this.SMSFormData.phone })
        .then(res => {
          this.countDown();
        })
        .catch(err => {});
    },
    countDown() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text =
        n +
        "s" +
        this.$t("permission_configuration_management.smsLogin.surplusTime");
      this.run = setInterval(() => {
        n = n - 1;
        if (n < 1) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
          clearInterval(this.run);
          return;
        }
        this.text =
          n +
          "s" +
          this.$t("permission_configuration_management.smsLogin.surplusTime");
        if (
          this.text <
          0 +
            "s" +
            this.$t("permission_configuration_management.smsLogin.surplusTime")
        ) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
        }
      }, 1000);
    },
    //localStorage 存储数组对象的方法
    saveObjArr: function(name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },
    query: function() {
      this.$api.resourceSecurityLogConfiguration.query({}).then(res => {
        this.instanceRecoveryForm.disclaimer = res.data.agree;
      });
    },
    // 查询版本号
    getVersion: function() {
      this.$api.user.getVersion({}).then(res => {
        this.version = res.data;
      });
    },
    // 中英文切换
    changeLanguage(language) {
      if (this.language == "zh") {
        localStorage.setItem("locale", "zh");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.$Message.success("切换为中文!");
      } else if (this.language == "en") {
        localStorage.setItem("locale", "en");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.$Message.success("Switch to English!");
      }
      this.text = this.$t(
        "permission_configuration_management.smsLogin.getVerificationCode"
      );
      this.productList = [
        {
          value: 1,
          label: this.$t(
            "permission_configuration_management.smsLogin.subscribe"
          )
        },
        {
          value: 2,
          label: this.$t("permission_configuration_management.smsLogin.doc")
        }
      ];
    },
    loginSMS(name) {
      // 验证码登录界面 请求验证码接口
      if (!this.SMSFormData.code) {
        this.$Message.error(
          this.$t(
            "permission_configuration_management.smsLogin.plaVerificationCode"
          )
        );
        return;
      }
      this.$api.user
        .codeVerify(this.SMSFormData)
        .then(res => {
          clearInterval(this.run);
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.getVerificationCode"
          );
          if (this.getSMSData) {
            setCookie(global.cookieName, this.formValidate.name);
            // 获取令牌
            setCookie("Authorization", this.getSMSData.data.token);
            // 获取公司ID
            setCookie(global.companyId, this.getSMSData.data.companyId);
            // 获取
            localStorage.setItem("locale", this.language);
            this.$i18n.locale = localStorage.getItem("locale");
            // 获取安全日志配置
            this.$api.resourceSecurityLogConfiguration.query({}).then(r => {
              setCookie("securityLogRetentionTime", r.data.keepTime);
            });
            this.getCurrentUser();
            topHead.methods.init(this.formValidate.name);
            // 获取菜单
            /****************************************************/
            var userDTO = {
              language: this.language == "zh" ? 0 : 1
            };
            this.$api.user.changeLanguage(userDTO).then(res => {
              // todo 后期待优化
              window.localStorage.removeItem("router");
              this.$api.security
                .userMenu("userName", getCookie(global.cookieName))
                .then(res => {
                  this.getRouter = res.data;
                  this.saveObjArr("router", this.getRouter); //存储路由到localStorage
                  if (this.getRouter[0].type == undefined) {
                    this.$router.replace(this.getRouter[0].path);
                  } else {
                    this.$router.replace(this.getRouter[0].children[0].path);
                  }
                  this.$Message.success("登录成功!");
                });
            });
            // 判断当前用户是否冠闵用户 如果是定时触发播放音乐
            if (res.data.companyId == 1) {
              window.setInterval(() => {
                setTimeout(() => {
                  this.$api.ticket
                    .isNeedReminder({
                      duration: 12
                    })
                    .then(res => {
                      if (res.data == true) {
                        this.music = new Audio("./static/tip.mp3");
                        this.music.play();
                        this.$Notice.open({
                          title: "通知",
                          desc: "你有一条新的待办事项 ",
                          duration: 10
                        });
                      }
                    });
                }, 0);
              }, 10 * 60 * 1000);
            }
          } else {
            // 网断了的情况
            this.$Message.error("服务器异常,请稍后重试!");
          }
          // 查询当前用户的权限集合
          /****************************************************/
          this.$api.menu.jurisdictionList({}).then(res => {
            this.menuList = res.data;
            this.saveObjArr("permissionsList", this.menuList); //存储路由到localStorage
          });
        })
        .catch(err => {});
    },
    // 登录
    login: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.user
            .login({
              name: this.formValidate.name,
              password: this.formValidate.password
            })
            .then(res => {
              clearInterval(this.run);
              this.disabled = false;
              this.text = this.$t(
                "permission_configuration_management.smsLogin.getVerificationCode"
              );
              // if (res) {
              //   /*
              //               1. 如果登录成功，设置存在cookie里面的
              //                   userNameSme：值为用户自己输入的用户名，
              //                   设置token ：值为接口返回，
              //                   获取公司id : 值为接口返回
              //               2. 设置存在 localStorage 里面的
              //                   设置local 中文还是英文
              //               3. 获取左侧菜单
              //                   根据用户名拿到后端返回的路由数组，存储路由数组到 localStorage 里面
              //               4. 判断当前用户是否冠闵用户 如果是定时触发播放音乐
              //               查询当前用户的权限集合：展示的菜单，按钮
              //                                           */
              // }
              this.getStatus = res.data.mfaStatus ? 1 : 0;
              if (this.getStatus == 1) {
                this.getSMSData = res;
                this.getUserId = res.data.id;
                let index = res.data.phone.lastIndexOf("\-");
                let frontPhone = res.data.phone.substring(0, index);
                let afterPhone = res.data.phone.substring(
                  index + 1,
                  res.data.phone.length
                );
                var reg = /^(\d{3})\d*(\d{4})$/;
                var str2 = afterPhone.replace(reg, "$1****$2");
                this.showPhone = frontPhone + "-" + str2;
                this.SMSFormData.phone = res.data.phone;
                this.showLogin = true;
              } else {
                if (res) {
                  clearInterval(this.run);
                  setCookie(global.cookieName, this.formValidate.name);
                  // 获取令牌
                  setCookie("Authorization", res.data.token);
                  // 获取公司ID
                  setCookie(global.companyId, res.data.companyId);
                  // 获取
                  localStorage.setItem("locale", this.language);
                  this.$i18n.locale = localStorage.getItem("locale");
                  // 获取安全日志配置
                  this.$api.resourceSecurityLogConfiguration
                    .query({})
                    .then(r => {
                      setCookie("securityLogRetentionTime", r.data.keepTime);
                    });
                  this.getCurrentUser();
                  topHead.methods.init(this.formValidate.name);
                  // 获取菜单
                  /****************************************************/
                  var userDTO = {
                    language: this.language == "zh" ? 0 : 1
                  };
                  this.$api.user.changeLanguage(userDTO).then(res => {
                    // todo 后期待优化
                    window.localStorage.removeItem("router");
                    this.$api.security
                      .userMenu("userName", getCookie(global.cookieName))
                      .then(res => {
                        this.getRouter = res.data;
                        this.saveObjArr("router", this.getRouter); //存储路由到localStorage
                        if (this.getRouter[0].type == undefined) {
                          this.$router.replace(this.getRouter[0].path);
                        } else {
                          this.$router.replace(
                            this.getRouter[0].children[0].path
                          );
                        }
                        this.$Message.success("登录成功!");
                      });
                  });
                  // 判断当前用户是否冠闵用户 如果是定时触发播放音乐
                  if (res.data.companyId == 1) {
                    window.setInterval(() => {
                      setTimeout(() => {
                        this.$api.ticket
                          .isNeedReminder({
                            duration: 12
                          })
                          .then(res => {
                            if (res.data == true) {
                              this.music = new Audio("./static/tip.mp3");
                              this.music.play();
                              this.$Notice.open({
                                title: "通知",
                                desc: "你有一条新的待办事项 ",
                                duration: 10
                              });
                            }
                          });
                      }, 0);
                    }, 10 * 60 * 1000);
                  }
                } else {
                  // 网断了的情况
                  this.$Message.error("服务器异常,请稍后重试!");
                }
                // 查询当前用户的权限集合
                /****************************************************/
                this.$api.menu.jurisdictionList({}).then(res => {
                  this.menuList = res.data;
                  this.saveObjArr("permissionsList", this.menuList); //存储路由到localStorage
                });
              }
            });
        } else {
          this.$Message.error("登录失败!");
        }
      });
    },
    // 跳转到注册
    register: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        // 获取部门列表数据
        this.$api.user
          .listDepartmentRegister("language", localStorage.getItem("locale"))
          .then(res => {
            this.departmentList = res.data;
            // 路由跳转到注册界面 并传数组过去
            this.$router.push({
              path: "/register",
              query: {
                companyIdList: this.companyIdList,
                departmentList: this.departmentList
              }
            });
          });
      });
    },
    // 跳转到邮件验证重置密码
    forgetPassword: function() {
      if (!this.formValidate.name.trim()) {
        this.$Message.error("请先输入用户名后再点击忘记密码!");
        return;
      }
      // 路由跳转到忘记密码界面
      this.$router.push({
        path: "/forgetPassword?userName=" + this.formValidate.name
      });
    },
    //  取得当前用户
    getCurrentUser: function() {
      this.currentName = getCookie(global.cookieName);
    },
    handleChangeProduct(data) {
      if (data == 1) {
        this.$router.push({ path: "/selectVersion" });
      } else {
        this.$router.push({ path: "/pageManual" });
      }
    }
  }
};
</script>
<style scoped>
.tel-container {
  display: flex;
  align-items: center;
  height: 52px;
}

.tel-container >>> .ivu-select-single .ivu-select-selection {
  background: none;
  border: none;
  outline: none;
  border: none;
}
/* 去掉点击下拉框时的阴影 */
.tel-container >>> .ivu-select-single .ivu-select-selection:focus {
  box-shadow: 0 0 02px transparent;
}
.tel-container >>> .ivu-select-selected-value {
  color: #c5c8ce;
}
.tel-container
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  color: #c5c8ce;
  text-align: center;
}
.tel-container >>> .ivu-select {
  width: 70px;
}
.tel-login-user >>> input::-webkit-outer-spin-button,
.tel-login-user >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tel-login-user >>> input[type="number"] {
  -moz-appearance: textfield;
}
.my-el-select /deep/ .el-input .el-input__inner {
  border-color: #dcdfe6 !important;
}
input {
  height: 20px;
}
p {
  margin-left: 20px;
}
.login {
  position: fixed;
  left: 0;
  right: 0;
  background-color: #2d3a4b;
  top: 0;
  bottom: 0;
}
.login-content {
  width: 448px;
  height: 330px;
  margin-top: -165px;
  margin-left: -181px;
  position: fixed;
  top: 45%;
  left: 47%;
}
.login-title {
  font-size: 26px;
  color: #eee;
  margin: 0px auto 40px auto;
  text-align: center;
  font-weight: bold;
}
.login-user {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #454545;
  line-height: 52px;
  height: 52px;
  font-size: 14px;
  margin-bottom: 22px;
}
.login-user input {
  background: transparent;
  border: 0px;
  -webkit-appearance: none;
  border-radius: 0px;
  padding: 12px 5px 12px 15px;
  color: #eee;
  height: 47px;
  width: 395px;
  outline: none;
}
.login-icon {
  padding-left: 13px;
  color: #889aa4;
  font-size: 18px;
  margin-top: -4px;
}
.login-content button:not(.btn-text) {
  width: 100%;
  height: 40px;
  font-size: 14px;
  margin-bottom: 22px;
}
.btn-text {
  background: none;
  color: #c5c8ce;
}
.btn-text:hover {
  background: none;
}
.register {
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  width: 75px;
  float: left;
}
.forget-password {
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  float: right;
}
.top-head-left {
  float: left;
  padding: 10px;
}
.top-head-right {
  min-width: 104px;
  float: right;
  line-height: 60px;
}
.top-head-right-float {
  float: right;
  display: flex;
}
.top-head-right-float >>> .ivu-select-selection {
  background: transparent;
  border: 0;
  box-shadow: none;
}
.top-head-right-prev {
  min-width: 104px;
  flex: 1;
  line-height: 60px;
  margin: 0 20px;
}
.top-head-right {
  min-width: 104px;
  /* float: right; */
  line-height: 60px;
  flex: 1;
}
.top-head-right >>> .ivu-select-selection {
  background: transparent;
  border: 0;
  box-shadow: none;
}
.top-head-right >>> .ivu-select-selected-value {
  color: #fff;
}
.top-head-right >>> .ivu-select-arrow {
  position: absolute;
  top: 50%;
  right: 8px;
  line-height: 1;
  transform: translateY(-50%);
  font-size: 14px;
  color: #808695;
  transition: all 0.2s ease-in-out;
}
.top-head-right >>> .ivu-select-placeholder {
  color: #fff;
}
.top-head-right-first {
  /* float: right; */
}
.top-head-right-prev
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/Login.vue